import { QuestionGroupStatus } from '@exam-management/graphql';
import { Label, LabelColor, type LabelProps } from '@shared/components';

export interface ItemSetStatusTagProps extends LabelProps {
  status: QuestionGroupStatus;
}

export const ITEM_SET_STATUS_COLOR = {
  [QuestionGroupStatus.Draft]: LabelColor.INFO,
  [QuestionGroupStatus.PreDraft]: LabelColor.INFO,
  [QuestionGroupStatus.Published]: LabelColor.SUCCESS,
  [QuestionGroupStatus.Unpublished]: LabelColor.WARNING,
  [QuestionGroupStatus.Disabled]: LabelColor.GREY,
};

export const ITEM_SET_STATUS_TEXT = {
  [QuestionGroupStatus.PreDraft]: 'Pre-Draft',
  [QuestionGroupStatus.Draft]: 'Draft',
  [QuestionGroupStatus.Published]: 'Published',
  [QuestionGroupStatus.Unpublished]: 'Pending',
  [QuestionGroupStatus.Disabled]: 'Disabled',
};

export default function ItemSetStatusTag(props: Readonly<ItemSetStatusTagProps>) {
  const { status, ...restProps } = props;

  // NOTE: Na status does not have a status tag
  if (status === QuestionGroupStatus.Na || status === QuestionGroupStatus.InDevelopment) {
    return null;
  }

  return (
    <Label
      color={ITEM_SET_STATUS_COLOR[status as keyof typeof ITEM_SET_STATUS_COLOR]}
      variant='outlined'
      {...restProps}
    >
      {ITEM_SET_STATUS_TEXT[status as keyof typeof ITEM_SET_STATUS_TEXT]}
    </Label>
  );
}
